<div class="relative flex h-full flex-col" *transloco="let t">
  <div class="flex items-center justify-between px-3 py-2.5">
    <div class="flex items-center gap-2">
      <div class="flex-1">
        <input iInput [(ngModel)]="textFilter" size="sm" [placeholder]="t('catalog-page.search_product_or_brand')" />
      </div>

      <app-compact-filter [filters]="filters() ?? []" (filterChange)="selectedFilters.set($event)" />
      <ISortSelect [sortByConfig]="sortByConfig" />
    </div>
    <div class="flex items-center gap-2">
      @if (isVendor()) {
        <a
          iButton
          variant="secondary"
          size="sm"
          routerLink="/product-center/catalog/upload"
          [queryParamsHandling]="'merge'"
          [class.disabled]="!!isReadOnly()"
        >
          <IIcon name="plus" />
          {{ t("common.add_asins") }}
        </a>
      }
      <button iButton variant="secondary" size="sm" [disabled]="!!isReadOnly()" (click)="uploadCatalogData()">
        <IIcon name="import" />
        {{ t("common.import") }}
      </button>
      <button
        iButton
        [iDropdownMenuTrigger]="exportMenu"
        placement="bottom-end"
        variant="secondary"
        [disabled]="!!isReadOnly()"
      >
        <IIcon name="upload" />
        {{ t("common.export") }}
      </button>

      <ng-template #exportMenu>
        <IDropdownMenu>
          <button iDropdownMenuItem (click)="exportCatalog()">
            <IIcon name="fileSpreadsheet" />
            {{ t("catalog-page.export_catalog_as_csv") }}
          </button>
          <button iDropdownMenuItem (click)="exportSeedsAsCsv()">
            <IIcon name="fileSpreadsheet" />
            {{ t("catalog-page.export_seed_blacklist_as_csv") }}
          </button>
          <button iDropdownMenuItem (click)="exportCogs()">
            <IIcon name="fileSpreadsheet" />
            {{ t("catalog-page.export_cost_of_goods_as_csv") }}
          </button>
          <button iDropdownMenuItem (click)="exportProductTags()">
            <IIcon name="fileSpreadsheet" />
            {{ t("catalog-page.export_custom_fields_as_csv") }}
          </button>
        </IDropdownMenu>
      </ng-template>
      <button iButton variant="secondary" size="sm" [disabled]="!!isReadOnly()" (click)="openProductTagSettings()">
        <IIcon name="gear" />
        {{ t("catalog-page.custom_field_settings") }}
      </button>
    </div>
  </div>

  <div class="scrollbar min-h-0 flex-[1_1_0] overflow-auto">
    <table iTable>
      <thead iTableHead class="sticky top-0 left-0 z-50 border-none">
        <tr iTableRow>
          @let productsLength = filteredCatalog()?.length;
          <th iTableTh>
            <div class="flex items-center gap-2">
              @if (!isReadOnly() && filteredCatalog()?.length) {
                <ICheckbox [value]="isAllSelected()" (valueChange)="toggleSelectAllProducts()" class="mr-1.5" />
              }
              {{ t("common.asin") }}
              <IBadge [label]="productsLength?.toString() ?? '0'" color="gray" size="xs" />
            </div>
          </th>
          <th iTableTh>{{ t("common.product") }}</th>
          <th iTableTh>{{ t("common.brand") }}</th>
          <th iTableTh>{{ t("common.strategies") }}</th>
          <th iTableTh class="text-nowrap">{{ t("common.cost_of_goods") }}</th>
          <th iTableTh>{{ t("common.seeds") }}</th>
          <th iTableTh>{{ t("common.blacklist") }}</th>
          <th iTableTh class="text-nowrap">{{ productTag1Name() }}</th>
          <th iTableTh class="text-nowrap">{{ productTag2Name() }}</th>
        </tr>
      </thead>
      <tbody iTableBody>
        @for (product of catalogPaginated(); track product.asin) {
          <tr
            iTableRow
            app-catalog-row
            [isManaged]="true"
            [product]="product"
            [currencyCode]="currencyCode()"
            [currency]="currency()"
            [locale]="locale()"
            [isRowSelected]="selectedRows().has(product.asin!)"
            [ngClass]="{ 'bg-main-50 hover:!bg-main-50': selectedRows().has(product.asin!) }"
            (isRowSelectedChange)="onRowCheckboxClicked(product.asin!)"
          ></tr>
        }
      </tbody>
    </table>
  </div>

  <div>
    @if (managedCatalog()?.length && managedCatalog()!.length > DEFAULT_PAGE_SIZE) {
      <IPaginator
        [pageIndex]="pagination().pageIndex"
        [pageSize]="pagination().pageSize"
        [length]="filteredCatalog()?.length ?? 0"
        (paginationEvent)="pagination.set($event)"
        chatbotSafeArea
      />
    }
  </div>

  <app-catalog-toolbar [display]="selectedRowsCount() > 0 && !isReadOnly()">
    <ng-template>
      <div class="flex items-center gap-3.5">
        <div class="flex items-baseline gap-1">
          <IBadge [label]="selectedRowsCount().toString()" size="xs" />
          <span class="text-xs text-gray-600">selected</span>
        </div>
        <button iButton variant="secondary" (click)="groupEditProductTag(ProductTagField.FIELD1)">
          <IIcon name="edit" />
          {{ t("common.edit") + " " + productTag1Name() }}
        </button>
        <button iButton variant="secondary" (click)="groupEditProductTag(ProductTagField.FIELD2)">
          <IIcon name="edit" />
          {{ t("common.edit") + " " + productTag2Name() }}
        </button>

        <button iButton variant="destructive" (click)="updateProductsCatalog()">
          <IIcon name="packageMinus" />
          {{ t("catalog-page.stop_managing_button") }}
        </button>
        <button
          iButton
          variant="ghost"
          [iTooltip]="'Clear selection'"
          iTooltipPlacement="top-center"
          (click)="clearSelection()"
        >
          <IIcon name="close" />
        </button>
      </div>
    </ng-template>
  </app-catalog-toolbar>
</div>
